<template>
      <div class="infoCard">
       <b-table-simple>
            <b-thead>
                <b-th> {{$t('signal.list.signalsDate')}} </b-th>
                <b-th> {{$t('signal.list.processDate')}} </b-th>
                <b-th> {{$t('signal.list.time')}} </b-th>
                <b-th> {{$t('signal.alarmStatus.account')}} </b-th>
                <b-th> {{$t('signal.list.userNote')}} </b-th>
            </b-thead>
            <b-tbody>
                <b-tr v-for="note in data.signal_note" :key="note.date"> 
                    <b-td> {{moment(data.signal_date)}} </b-td>
                    <b-td> {{moment(note.date)}} </b-td>
                    <b-td> <b-badge :variant="getVariant(duration(note.date, data.signal_date ))"> {{time(note.date, data.signal_date )}} </b-badge> </b-td>
                    <b-td> {{note.user_info.username}}</b-td>
                    <b-td> {{note.note}} </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
     
    </div>
</template>

<style lang="css" scoped > 
    @import "../styles/add.min.css"; 
</style>

<script>
    import i18n from '@/plugins/i18n';
    import Multiselect from 'vue-multiselect'
    import { Datetime } from 'vue-datetime';
    import moment from 'moment'
    import humanizeDuration from 'humanize-duration'

    import { VueEditor } from "vue2-editor";

    export default {
        name: "Notes",
       
        data: function() {
            return {
               
            }
        },
        props: {
            data: Object,
            save: Boolean,
            saveState: Function,
            modalEvent: Function,
            modalName: String
        },
        watch: {
            save: function(data){
                this.saveState(false)
                this.modalEvent(false)

            }
        },
        methods:{
            moment: function(data){
                return moment(data).format('DD MMMM YYYY HH:mm');
            },
            time: function(noteDate, signalDate){
                return humanizeDuration(moment.duration(moment(noteDate).diff(moment(signalDate))),{ language: localStorage.getItem('lang') })
            },
             duration: function(noteDate, signalDate){
                return moment(noteDate).diff(moment(signalDate), 'second')
            },
            getVariant: function(data){
                if(data < 61){
                    return 'primary'
                }else if(data < 301){
                    return 'success'
                }else if(data < 901){
                    return 'warning'
                }else{
                    return 'danger'
                }
            }
        }
        
    }
</script>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Signal/modals/NoteHistory.vue